import { useMemo } from 'react';

const usePropertyRules = ({ policies, intl }) => {
  const features = useMemo(() => {
    if (!policies) return [];

    const result = [];
    const rulesItems = [];

    // Campfires
    const renderCampfires = () => {
      const campfires = [];

      if (policies.campfires?.includes('firepit')) {
        campfires.push(intl.formatMessage({ id: 'ListingPage.rules.campfires.firepit' }));
      }

      if (policies.campfires?.includes('fireplace')) {
        campfires.push(intl.formatMessage({ id: 'ListingPage.rules.campfires.fireplace' }));
      }

      if (policies.campfires?.includes('firewood_provided')) {
        campfires.push(intl.formatMessage({ id: 'ListingPage.rules.campfires.firewoodProvided' }));
      }

      return campfires.length > 0 ? campfires.join('. ') : undefined;
    };

    rulesItems.push({
      label: `${intl.formatMessage({ id: 'ListingPage.rules.campfires' })}:`,
      subtitle: policies.allowsCampfires
        ? intl.formatMessage({ id: 'ListingPage.rules.allowed' }) +
          (renderCampfires() ? ` • ${renderCampfires()}` : '')
        : intl.formatMessage({ id: 'ListingPage.rules.notAllowed' }),
      isInline: true,
    });

    // Pets
    const petsSubtitle = policies.allowsPets
      ? intl.formatMessage({ id: 'ListingPage.rules.allowedOnProperty' })
      : intl.formatMessage({ id: 'ListingPage.rules.notAllowedOnProperty' });

    rulesItems.push({
      label: `${intl.formatMessage({ id: 'ListingPage.rules.pets' })}:`,
      subtitle: petsSubtitle + (policies.petsInfo ? ` • ${policies.petsInfo}` : ''),
      isInline: true,
    });

    // ATVs
    if (policies.allowsATV !== undefined) {
      const atvSubtitle = policies.allowsATV
        ? intl.formatMessage({ id: 'ListingPage.rules.allowed' })
        : intl.formatMessage({ id: 'ListingPage.rules.notAllowed' });

      rulesItems.push({
        label: `${intl.formatMessage({ id: 'ListingPage.rules.atv' })}:`,
        subtitle: atvSubtitle + (policies.ATVInfo ? ` • ${policies.ATVInfo}` : ''),
        isInline: true,
      });
    }

    // Drive-in Access
    const driveInSubtitle = policies.hasDriveInAccess
      ? intl.formatMessage({ id: 'ListingPage.rules.yes' })
      : intl.formatMessage({ id: 'ListingPage.rules.no' });

    rulesItems.push({
      label: `${intl.formatMessage({ id: 'ListingPage.rules.driveInAccess' })}:`,
      subtitle:
        driveInSubtitle + (policies.driveInAccessInfo ? `: ${policies.driveInAccessInfo}` : ''),
      isInline: true,
    });

    // Walk-in Access
    const walkInSubtitle = policies.hasWalkInAccess
      ? intl.formatMessage({ id: 'ListingPage.rules.yes' })
      : intl.formatMessage({ id: 'ListingPage.rules.no' });

    rulesItems.push({
      label: `${intl.formatMessage({ id: 'ListingPage.rules.walkInAccess' })}:`,
      subtitle:
        walkInSubtitle + (policies.walkInAccessInfo ? ` • ${policies.walkInAccessInfo}` : ''),
      isInline: true,
    });

    // Vehicles
    if (policies.vehicles !== undefined && policies.vehicles !== null) {
      rulesItems.push({
        label: `${intl.formatMessage({ id: 'ListingPage.rules.vehicles' })}:`,
        subtitle:
          intl.formatMessage(
            { id: 'ListingPage.rules.numberAllowed' },
            { number: policies.vehicles }
          ) + (policies.vehiclesInfo ? ` • ${policies.vehiclesInfo}` : ''),
        isInline: true,
      });
    }

    // Landowner Rules (Sportsmen Policies)
    if (policies.sportsmenPolicies) {
      rulesItems.push({
        label: `${intl.formatMessage({ id: 'ListingPage.rules.landownerRules' })}:`,
        subtitle: policies.sportsmenPolicies,
        isInline: true,
      });
    }

    // Cancellation Policy
    rulesItems.push({
      label: `${intl.formatMessage({ id: 'ListingPage.rules.cancellationPolicyLabel' })}:`,
      subtitle: intl.formatMessage({ id: 'ListingPage.rules.cancellationPolicy' }),
      isInline: true,
    });

    if (rulesItems.length > 0) {
      result.push({
        items: rulesItems,
      });
    }

    return result;
  }, [policies, intl]);

  return { features };
};

export default usePropertyRules;
